// EmailPreview.js
import React, { useState } from 'react';
import { Box, Select, MenuItem, Typography, Paper } from '@mui/material';
import { emailTemplates } from './emailTemplates';
import logo from '../../assets/xpdlogo.png'; // Adjust the path as necessary
// dummyData.js
export const dummyData = {
    logo : logo,
    welcome: {
      name: "John Smith",
      email: "john.smith@example.com",
      accountType: "Premium",
      registrationDate: new Date().toISOString(),
      referralCode: "JOHN123"
    },
    
    passwordReset: {
      resetLink: "https://yourapp.com/reset-password?token=xyz123",
      email: "john.smith@example.com",
      requestTime: new Date().toISOString(),
      expiryTime: new Date(Date.now() + 30 * 60000).toISOString(), // 30 minutes from now
      deviceInfo: "Chrome on MacOS"
    },
    
    transferAlert: {
      amount: "0.05",
      currency: "BTC",
      type: "Deposit",
      transactionId: "TXN123456789",
      status: "Completed",
      timestamp: new Date().toISOString(),
      fromAddress: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa",
      toAddress: "3J98t1WpEZ73CNmQviecrnyiWrnqRhWNLy",
      networkFee: "0.0001 BTC",
      confirmations: 6
    },
    
    verifyEmail: {
      verificationCode: "847591",
      email: "john.smith@example.com",
      expiryMinutes: 10,
      attempts: 3,
      deviceInfo: "Chrome on MacOS",
      location: "New York, USA"
    }
  };
  

const EmailPreview = () => {
  const [selectedTemplate, setSelectedTemplate] = useState('welcome');

  const getTemplateHtml = () => {
    return {
      __html: emailTemplates[selectedTemplate](dummyData[selectedTemplate])
    };
  };

  return (
    <Box sx={{ p: 3, maxWidth: '100%' }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ mb: 2, color: '#7517a7' }}>
          Email Template Preview
        </Typography>
        
        <Select
          value={selectedTemplate}
          onChange={(e) => setSelectedTemplate(e.target.value)}
          sx={{ 
            minWidth: 200,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#7517a7',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#7517a7',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#7517a7',
            },
          }}
        >
          <MenuItem value="welcome">Welcome Email</MenuItem>
          <MenuItem value="passwordReset">Password Reset</MenuItem>
          <MenuItem value="transferAlert">Transfer Alert</MenuItem>
          <MenuItem value="verifyEmail">Email Verification</MenuItem>
        </Select>
      </Box>

      <Paper 
        elevation={3}
        sx={{ 
          p: 2,
          backgroundColor: '#f8f9fa',
          borderRadius: 2,
          overflow: 'auto'
        }}
      >
        <Box 
          dangerouslySetInnerHTML={getTemplateHtml()} 
          sx={{ 
            '& table': {
              margin: '0 auto',
              backgroundColor: '#ffffff'
            }
          }}
        />
      </Paper>

      <Box sx={{ mt: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Preview Data:
        </Typography>
        <pre
          style={{
            backgroundColor: '#f1f1f1',
            padding: '16px',
            borderRadius: '4px',
            overflow: 'auto'
          }}
        >
          {JSON.stringify(dummyData[selectedTemplate], null, 2)}
        </pre>
      </Box>
    </Box>
  );
};

export default EmailPreview;
